import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { DashboardApi } from '../../../services'
import { WaterTestStripState } from '../waterTestStrip.slice'
import { RootState } from '../../store';
import { StorageUtils } from '../../Verification';
import { WaterQualityParameter } from '../../../types/TestParameter';


export const manualAnalyzeTestStripAsync = createAsyncThunk(
  'waterTestStrip/manualAnalyze',
  async (waterQualityParameters: WaterQualityParameter[], {getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const { verifiedEmail, isVerified } = state.verification;
      const savedState = StorageUtils.getVerificationState();
      const email = verifiedEmail || savedState?.email;
      
      if (!isVerified || !savedState?.isVerified) {
        throw new Error('Verification required');
      }
       const response = await DashboardApi.manualAnalyzeWaterTestStrip({email, waterQualityParameters})
       return (response as AxiosResponse<any>).data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error?.response?.data || 'Failed to manually analyze water test strip');
    }
  }
);

export const manualAnalyzeTestStripAsyncBuilder = (
  builder: ActionReducerMapBuilder<WaterTestStripState>
) => {
  builder.addCase(manualAnalyzeTestStripAsync.pending, (state) => {
    state.loading = true;
    state.status = 'uploading';
    state.success = false;
    state.error = null;
  });

  builder.addCase(
    manualAnalyzeTestStripAsync.fulfilled,
    (state, action) => {
      state.loading = false;
      state.success = true;
      state.status = 'completed';
      state.data = action.payload.result;
      }
  );

  builder.addCase(
    manualAnalyzeTestStripAsync.rejected,
    (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = false;
      state.status = 'failed';
      state.error = action.payload;
    }
  );
};